import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-2" }
const _hoisted_2 = { class: "pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadialProgress = _resolveComponent("RadialProgress")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      align: "center",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          lg: "4",
          md: "4",
          cols: "12"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadialProgress, {
              diameter: 120,
              animateSpeed: 1000,
              innerStrokeWidth: 5,
              strokeWidth: 3,
              "completed-steps": _ctx.seconds,
              "total-steps": _ctx.totalSteps
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.timerOutput), 1)
              ]),
              _: 1
            }, 8, ["completed-steps", "total-steps"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          lg: "8",
          md: "8",
          cols: "12"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.message), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}